var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _rect2, _path23, _path24, _g4, _circle, _circle2, _circle3, _g5, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxQuestionnaireIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 174,
    viewBox: "0 0 375 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12326_142805)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 173.616,
    fill: "#E6F1FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12326_142805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 27,
    width: 127,
    height: 179
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 27.0161H234.813V205.457H108V27.0161Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12326_142805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.804 205.458H111.005C109.346 205.458 107.998 204.109 107.998 202.445V30.0236C107.998 28.3594 109.346 27.0161 111.005 27.0161H231.804C233.469 27.0161 234.812 28.3594 234.812 30.0236V202.445C234.812 204.109 233.469 205.458 231.804 205.458Z",
    fill: "#031D43"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.552 201.949H111.758C111.207 201.949 110.756 201.498 110.756 200.946V44.5591C110.756 44.0027 111.207 43.5566 111.758 43.5566H230.552C231.109 43.5566 231.555 44.0027 231.555 44.5591V200.946C231.555 201.498 231.109 201.949 230.552 201.949Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.103 202.198H113.015C111.902 202.198 111.01 201.301 111.01 200.193V47.3145L183.103 202.198Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.26 39.2949H131.057C128.841 39.2949 127.047 41.0894 127.047 43.3048V55.8359H217.27V43.3048C217.27 41.0894 215.476 39.2949 213.26 39.2949Z",
    fill: "#E8E8E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.725 30.2734H145.594C143.378 30.2734 141.584 32.0679 141.584 34.2834V46.8144H202.735V34.2834C202.735 32.0679 200.936 30.2734 198.725 30.2734Z",
    fill: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12326_142805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 21,
    width: 20,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.633 21H181.68V40.0469H162.633V21Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12326_142805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.68 30.5231C181.68 35.7811 177.414 40.0467 172.156 40.0467C166.898 40.0467 162.633 35.7811 162.633 30.5231C162.633 25.2651 166.898 20.9995 172.156 20.9995C177.414 20.9995 181.68 25.2651 181.68 30.5231Z",
    fill: "#E8E8E8"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.165 30.5231C175.165 32.1872 173.817 33.5305 172.158 33.5305C170.499 33.5305 169.15 32.1872 169.15 30.5231C169.15 28.864 170.499 27.5156 172.158 27.5156C173.817 27.5156 175.165 28.864 175.165 30.5231Z",
    fill: "#041E42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.047 56.5879H217.27V52.5786H127.047V56.5879Z",
    fill: "#9B9B9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.584 42.303H202.735V39.7969H141.584V42.303Z",
    fill: "#9B9B9B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.565 98.73C133.565 100.805 131.881 102.489 129.806 102.489C127.726 102.489 126.047 100.805 126.047 98.73C126.047 96.6549 127.726 94.9707 129.806 94.9707C131.881 94.9707 133.565 96.6549 133.565 98.73Z",
    fill: "#29B8FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.578 99.9837H215.266V97.4775H139.578V99.9837Z",
    fill: "#E8E8E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.565 112.764C133.565 114.839 131.881 116.523 129.806 116.523C127.726 116.523 126.047 114.839 126.047 112.764C126.047 110.689 127.726 109.005 129.806 109.005C131.881 109.005 133.565 110.689 133.565 112.764Z",
    fill: "#9B9B9B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.578 114.018H215.266V111.512H139.578V114.018Z",
    fill: "#E8E8E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.565 126.798C133.565 128.878 131.881 130.557 129.806 130.557C127.726 130.557 126.047 128.878 126.047 126.798C126.047 124.723 127.726 123.039 129.806 123.039C131.881 123.039 133.565 124.723 133.565 126.798Z",
    fill: "#9B9B9B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.578 128.053H215.266V125.547H139.578V128.053Z",
    fill: "#E8E8E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.565 140.837C133.565 142.912 131.881 144.596 129.806 144.596C127.726 144.596 126.047 142.912 126.047 140.837C126.047 138.762 127.726 137.078 129.806 137.078C131.881 137.078 133.565 138.762 133.565 140.837Z",
    fill: "#9B9B9B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.578 142.088H215.266V139.582H139.578V142.088Z",
    fill: "#E8E8E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.565 154.87C133.565 156.945 131.881 158.629 129.806 158.629C127.726 158.629 126.047 156.945 126.047 154.87C126.047 152.795 127.726 151.111 129.806 151.111C131.881 151.111 133.565 152.795 133.565 154.87Z",
    fill: "#9B9B9B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.578 156.123H215.266V153.616H139.578V156.123Z",
    fill: "#E8E8E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.165 30.5231C175.165 32.1872 173.817 33.5305 172.158 33.5305C170.499 33.5305 169.15 32.1872 169.15 30.5231C169.15 28.864 170.499 27.5156 172.158 27.5156C173.817 27.5156 175.165 28.864 175.165 30.5231Z",
    fill: "#041E42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12326_142805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 27,
    width: 7,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.146 30.5232C169.146 32.1873 170.5 33.5306 172.159 33.5306C173.823 33.5306 175.166 32.1873 175.166 30.5232C175.166 28.8641 173.823 27.5107 172.159 27.5107C170.5 27.5107 169.146 28.8641 169.146 30.5232Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12326_142805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.169 31.5265C176.169 33.1856 174.821 34.5339 173.162 34.5339C171.498 34.5339 170.154 33.1856 170.154 31.5265C170.154 29.8624 171.498 28.519 173.162 28.519C174.821 28.519 176.169 29.8624 176.169 31.5265Z",
    fill: "#686868"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.78 45.5601C220.54 45.0789 219.557 44.0113 217.271 43.5552V56.5874C220.279 50.0713 221.783 47.5651 220.78 45.5601Z",
    fill: "#041E42"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 249.381,
    y: 106.234,
    width: 6.40862,
    height: 11.9017,
    transform: "rotate(-45 249.381 106.234)",
    fill: "#FFC300"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.076 116.915C257.382 116.197 257.391 115.054 258.098 114.348L262.026 110.42C262.732 109.713 263.875 109.704 264.593 110.398L301.817 146.371L294.049 154.139L258.076 116.915Z",
    fill: "#00539D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12326_142805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 109,
    width: 45,
    height: 46
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.076 116.915C257.382 116.197 257.391 115.054 258.098 114.348L262.026 110.42C262.732 109.713 263.875 109.704 264.593 110.398L301.817 146.371L294.049 154.139L258.076 116.915Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12326_142805)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 234.813,
    cy: 86.813,
    r: 28.1522,
    transform: "rotate(-45 234.813 86.813)",
    fill: "#00539D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.814,
    cy: 86.813,
    r: 22.6591,
    transform: "rotate(-45 234.814 86.813)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12326_142805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 64,
    width: 46,
    height: 46
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.814,
    cy: 86.813,
    r: 22.6591,
    transform: "rotate(-45 234.814 86.813)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12326_142805)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.09 90.6293C237.09 91.0565 236.841 91.377 236.378 91.377H233.494C233.138 91.377 232.818 91.0921 232.818 90.7005V87.8878C232.818 86.0678 234.251 84.856 235.574 83.7366C236.711 82.7756 237.767 81.8827 237.767 80.7315C237.767 79.4498 236.698 78.3461 234.918 78.3461C233.234 78.3461 232.278 79.1811 231.601 79.7719C231.405 79.943 231.233 80.0936 231.073 80.1975C230.788 80.3755 230.539 80.3755 230.29 80.1619L228.617 78.5241C228.332 78.2749 228.367 77.8477 228.617 77.5984C228.617 77.5984 231.038 74.4653 235.595 74.4653C239.333 74.4653 242.502 76.9576 242.502 80.4467C242.502 82.9746 240.638 84.4483 239.099 85.6661C238.014 86.5236 237.09 87.2544 237.09 88.1371V90.6293ZM237.624 97.4295C237.624 98.8892 236.378 100.1 234.918 100.1C233.459 100.1 232.284 98.8892 232.284 97.4295C232.284 96.0053 233.459 94.7592 234.918 94.7592C236.378 94.7592 237.624 96.0053 237.624 97.4295Z",
    fill: "#00559B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12326_142805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 173.616,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxQuestionnaireIcon);
export default __webpack_public_path__ + "static/media/taxQuestionnaireIcon.3817397139e3ffad3f7cf35bdf52ea7b.svg";
export { ForwardRef as ReactComponent };